import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { withRouter } from 'react-router';

import ResetPasswordComponent from '../components/login/resetPassword/ResetPasswordComponent';
import SIGN_UP_RULES from '../validation/validationRules/signUp';
import { getValidationRules } from '../validation/validation';
import { sendForgotPasswordEmailAction, setLoading } from '../store/actions/session';

const mapStateToProps = ({ session: { isLoading } }, { history }) => ({ history, isLoading });

const mapDispatchToProps = {
    setLoading,
    sendForgotPasswordEmailAction,
};

const mergeProps = ({ history, ...state }, { sendForgotPasswordEmailAction, setLoading }) => ({
    ...state,
    setLoading,
    onCancel: () => history.push('/login'),
    onSubmit: (params) => sendForgotPasswordEmailAction(params),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(reduxForm({
    form: 'resetPassword',
    validate: getValidationRules(['email'], {email: SIGN_UP_RULES.email}),
})(ResetPasswordComponent)));



// WEBPACK FOOTER //
// ./src/containers/ResetPasswordContainer.js